<template>
  <div class="charts min-h-screen flex flex-col justify-between">
    <GeoSalesChart class="mb-8" />
    <LineSalesChart />
  </div>
</template>

<script>
import LineSalesChart from './Charts/LineSalesChart.vue';
import GeoSalesChart from './Charts/GeoSalesChart.vue';

export default {
  name: 'Charts',
  components: {
    LineSalesChart,
    GeoSalesChart,
  },
};
</script>

<style scoped>
  .charts {
    flex: 0 1 52%;
  }
</style>
